"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TRIGGERS = exports.ANNOTATION_STATUS = exports.ANNOTATION_RESOURCE_TYPE = exports.ANNOTATION_REQUEST_TYPE = exports.ANNOTATION_RELAY_TYPES = exports.ANNOTATION_POLICY = exports.ANNOTATION_ACTION_TYPE = exports.ANNOTATION = void 0;
var EVENT_TRIGGERS = exports.EVENT_TRIGGERS = {
  ANNOTATION_STROKE_DATA: 'annotation:strokeData',
  ANNOTATION_COMMAND: 'annotation:command'
};
var ANNOTATION_RESOURCE_TYPE = exports.ANNOTATION_RESOURCE_TYPE = 'AnnotationOnShare';
var ANNOTATION_RELAY_TYPES = exports.ANNOTATION_RELAY_TYPES = {
  ANNOTATION_CLIENT: 'annotation.client'
};
var ANNOTATION_STATUS = exports.ANNOTATION_STATUS = {
  NO_ANNOTATION: 'NO_ANNOTATION',
  RUNNING_ANNOTATION: 'RUNNING_ANNOTATION'
};
var ANNOTATION_POLICY = exports.ANNOTATION_POLICY = /*#__PURE__*/function (ANNOTATION_POLICY) {
  ANNOTATION_POLICY["ANYONE_CAN_ANNOTATE"] = "AnyoneCanAnnotate";
  ANNOTATION_POLICY["APPROVAL"] = "Approval";
  ANNOTATION_POLICY["ANNOTATION_NOT_ALLOWED"] = "AnnotationNotAllowed";
  return ANNOTATION_POLICY;
}({});
var ANNOTATION_REQUEST_TYPE = exports.ANNOTATION_REQUEST_TYPE = {
  ANNOTATION_MESSAGE: 'annotation_message'
};
var ANNOTATION_ACTION_TYPE = exports.ANNOTATION_ACTION_TYPE = /*#__PURE__*/function (ANNOTATION_ACTION_TYPE) {
  ANNOTATION_ACTION_TYPE["REQUESTED"] = "REQUESTED";
  ANNOTATION_ACTION_TYPE["ACCEPTED"] = "ACCEPTED";
  ANNOTATION_ACTION_TYPE["DECLINED"] = "DECLINED";
  ANNOTATION_ACTION_TYPE["OFFERED"] = "OFFERED";
  ANNOTATION_ACTION_TYPE["CANCELED"] = "CANCELED";
  ANNOTATION_ACTION_TYPE["EXPIRED"] = "EXPIRED";
  ANNOTATION_ACTION_TYPE["REVOKED"] = "REVOKED";
  ANNOTATION_ACTION_TYPE["CLOSED"] = "CLOSED";
  return ANNOTATION_ACTION_TYPE;
}({});
var ANNOTATION = exports.ANNOTATION = 'annotation';
//# sourceMappingURL=constants.js.map
